class PageFlow {
	constructor(continueFlow) {
		this.id;
		this.name;
		this.data = false;
		
		this.mobile;
		
		this.canvas;
		this.pointer;
		this.box;
		this.measureBox;
		this.showNotAgain = false;
		
		this.interactEl;
		this.receiverEl;
		
		this._index = 0;
		this.steps = [];
		this.selectedOption = false;
		
		this.initialised = false;
		this.helpOpenAtStart;
		this.forwards = true;
		
		this.resize = this.resize.bind(this);
		
		this.listeners = [];

		this.triggerStart = this.fromStart.bind(this);

		if (continueFlow) {
			let data = JSON.parse(continueFlow);
			this.id = data.id;
			this.steps = data.steps;
			this.launch(false);
		}
		else {
			this.check();
		}
	}
	
	get step() {
		if (!this.steps.length || !this.data) return null;

		let i = this.steps[this.steps.length -1];

		if (this.mobile && this.data.hasOwnProperty(i+100)) return this.data[i+100];
		return this.data[i];
	}

	get nextStep() {
		if (this.step === null) return false;
		let o = this.selectedOption !== false ? this.step.options[this.selectedOption] : this.step;
		return typeof o.next == 'undefined' ? false : o.next;
	}

	get action() {
		if (this.step === null || typeof this.step.action == 'undefined')
			return false;

		return this.step.action;
	}

	get before() {
		if (this.step === null) return false;
		let o = this.selectedOption !== false ? this.step.options[this.selectedOption] : this.step;
		return typeof o.before == 'undefined' ? false : o.before;
	}
	
	get after() {
		if (this.step === null) return false;
		let o = this.selectedOption !== false ? this.step.options[this.selectedOption] : this.step;
		return typeof o.after == 'undefined' ? false : o.after;
	}
	
	get end() {
		if (this.step === null) return false;
		return typeof this.step.finish === 'undefined' ? false : this.step.finish;
	}

	loadData(data) {
		this.data = {};
		for(let s of data) {
			this.data[s.step] = s;
		}
	}
	
	fromStart(id, showNotAgain) {
		this.id = id;
		this.steps = [1];
		this.data = false;
		this.launch(showNotAgain);
	}

	launch(showNotAgain) {
		this.showNotAgain = typeof showNotAgain == 'undefined' ? false : showNotAgain;

		this.init();
		if (this.data) {
			this.goto();
			return;
		}
		API.get(`flow/${this.id}`)
		.then(json => {
			if (json == null) this.cleanUP();
			else {
				this.loadData(json.data);
				this.goto();
			}
		})
	}
	
	check() {
		API.get('flow/check/' + baseName)
		.then(json => {
			if (json.flow) {
				this.id = json.flow.id;
				this.steps = [1];
				this.loadData(json.flow.data);
				this.launch(true);
			}
			else {
				this.setListeners(json.listeners);
			}
		});
	}
	
	setListeners(list) {
		for (let l of this.listeners) {
			remEv(l[0], l[1], () => this.triggerStart(l[2]));
		}
		this.listeners = [];
		for (let l of list) {
			let elms = document.querySelectorAll(l[0]);
			for (let e of elms) {
				onEv(e, l[1],  () => this.triggerStart(l[2]));
				this.listeners.push([e,l[1],l[2]]);
			}
		}
	}
	
	init() {
		if (this.initialised) return;
		
		this.canvas =htm('canvas', 'flow-canvas');
		this.layout();
		let ctx = this.canvas.getContext('2d');
		ctx.fillStyle = 'rgba(0,0,0,0.3)';
		ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
		
		this.mobile = window.innerWidth < 760;
		
		this.naCheckbox = chk('form-check-input', null, null, {
			'id': 'not-again-check'
		});
		this.naCheckbox.checked = false;
		
		this.pointer = div('flow-pointer animated');
		this.box = div('flow-prompt animated', [
			this.skipBtn = btn('skipBtn i-sm i-cross'),
			this.message = p(),
			this.options = div('container'),
			this.split = htm('hr'),
			div('row align-items-center', [
				div('col-auto', [
					this.backBtn = btn(null, _("Back")),
					this.naLabel = div('form-check', [
						this.naCheckbox,
						label('form-check-label', _("Don't show again"), null, {
							'for': 'not-again-check'
						}),
					]),
				]),
				div('col-auto ms-auto', [
					this.nextBtn = btn(null, _("Next")),
				]),
			]),
		]);
		this.measureBox = div('flow-prompt measure-clone', [
			this.message2 = p(),
			this.option2 = div(),
			this.split2 = htm('hr'),
			div('row align-items-center', [
				div('col-auto ms-auto', [
					this.measureBtn = btn(null, 'Fake'),
				]),
			]),
		]);
		this.receiverEl = div('flow-interactive');
		
		document.body.appendChild(this.canvas);
		document.body.appendChild(this.pointer);
		document.body.appendChild(this.box);
		document.body.appendChild(this.measureBox);
		document.body.appendChild(this.receiverEl);
		
		onEv(window, 'resize', this.resize);
		onEv(this.canvas, 'click', (event) => {stopEv(event);});
		onEv(this.skipBtn, 'click', this.skip.bind(this));
		onEv(this.backBtn, 'click', this.back.bind(this));
		onEv(this.nextBtn, 'click', this.next.bind(this));
		onEv(this.receiverEl, 'click', this.next.bind(this));
		onEv(document.body, 'keyup', (event) => {
			if (event.keyCode == AC.ESCAPE_KEY) this.skip();
		});
		
		if (help.isOpen) {
			this.helpOpenAtStart = true;
			help.hide();
		}
		else {
			this.helpOpenAtStart = false;
		}
		
		this.initialised = true;
	}
	
	resize() {
		this.layout();
		this.update();
	}
	
	async next(event) {
		if (event) stopEv(event);
		this.nextBtn.blur();
		this.forwards = true;
		
		let action = this.step.action;
		let interactive = this.step.interactive;
		let after = this.after;
		let next = this.nextStep;
		let finish = this.end;
		
		if (this.step.clearHist) this.steps = [];
		
		if (next) {
			this.steps.push(next);
			await this.setState(action);
		}
		
		if (this.interactEl && interactive) {
			this.interactEl.click();
		}
		
		if (next) this.goto();

		if (finish) this.finish();

		if (after) eval(after);
	}
	
	back(event) {
		if (event) stopEv(event);
		this.forwards = false;
		
		if (this.steps.length == 1)return;
		this.steps.pop();
		this.setState();
		
		this.goto();
	}

	prime(page, step) {
		API.post('flow/prime', {
			page: page,
			id: this.id,
			step: step
		});
	}

	async setState(action) {
		if (typeof(action) == 'undefined') {
			action = null;
		}
		
		await API.put(`flow/${this.id}/progress`, {
			page: baseName,
			steps: this.steps,
			action: action,
		});
	}
	
	setOption(value) {
		this.selectedOption = value;
		this.nextBtn.disabled = false;
	}
	
	goto() {
		if (!this.initialised) return;
		
		this.selectedOption = false;
		if (this.before) eval(this.before);
		
		setTimeout(() => this._goto(), 100);
	}
	
	_goto() {
		this.box.style.display = 'block';
		let showNA = this.step.step == 1 && this.showNotAgain;
		let showBack = this.steps.length > 1 && this.step.step < 900;
		let showNext = !this.step.element || !this.step.interactive;
		
		showBack = false; //TODO work out the best way to implement - disabled for now
		
		this.naLabel.style.display = showNA ? 'inline-block' : 'none';
		this.backBtn.style.display = showBack ? 'inline-block' : 'none';
		this.nextBtn.style.display = showNext ? 'inline-block' : 'none';
		
		this.nextBtn.disabled = this.step.options;
		this.nextBtn.innerText = (typeof this.step.label != 'undefined') ? 
			this.step.label : (this.step.next ? _('Next') : _('Finish'));

		this.split.style.display = this.split2.style.display = this.measureBtn.style.display = 
			showNA || showBack || showNext ? 'block' : 'none';
		this.message.innerHTML = this.message2.innerHTML = this.step.text;
		
		this.options.innerHTML = this.option2.innerHTML = '';
		if (typeof this.step.options !== 'undefined' && Array.isArray(this.step.options)){
			let i = 0;
			for(let o of this.step.options) {
				this.options.appendChild(
					div('form-check', [
							input('radio', 'form-check-input', null,{
								'change': this.setOption.bind(this, i)
							}, {
								'id': 'step-option-' + i,
								'name': 'stepOption',
								'value': i
							}),
						label('form-check-label', o.text, null, {
							'for': 'step-option-' + i
						})
					])
				);
				this.option2.appendChild(p(null, label(null, o.text)));
				i++;
			}
		}
		
		this.receiverEl.style.display = 'none';
		this.interactEl = null;
		if (this.step.element){
			this.interactEl = document.querySelector(this.step.element);
			if (this.interactEl == null) {
				this.steps.push(999);
				this.goto();
				return;
			}
			else {
				let r = this.interactEl.getBoundingClientRect();			
				if (
					r.bottom <= 0 ||
					r.right <= 0 ||
					r.left >= window.innerWidth ||
					r.top >= window.innerHeight
				) {
					if (this.forwards) this.next();
					else this.back();
					return;
				}
				if (this.step.interactive) {
					this.receiverEl.style.display = 'block';
				}
			}
		}
		
		this.layout();
		this.update();
		this.move();
	}
	
	layout() {
		this.canvas.width = window.innerWidth;
		this.canvas.height = window.innerHeight;
	}
	
	move() {
		this.until = Date.now() + 500;
		this.anim = setInterval(() => {
			if (Date.now() > this.until) clearInterval(this.anim);
			this.update();
		}, 20);
	}
	
	position() {
		let boxP = findPos(this.step.position, this.measureBox, this.interactEl, 10);
		let pointP = findPos(this.step.position, null, this.interactEl);
		
		this.box.style.top = boxP.top + 'px';
		this.box.style.left = boxP.left + 'px';
		this.pointer.style.top = pointP.top + 'px';
		this.pointer.style.left = pointP.left + 'px';
		this.pointer.style.transform = 'rotate(' + pointP.r + 'deg)';
		this.pointer.style.visibility = this.interactEl ? 'visible' : 'hidden';
	}
	
	update() {
		let ctx = this.canvas.getContext('2d');
		ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
		ctx.fillStyle = 'rgba(0,0,0,0.3)';
		ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
		
		if (this.interactEl) {
			let r = this.interactEl.getBoundingClientRect();
			if (this.step.interactive) {
				this.receiverEl.style.top = r.top - 5 + 'px';
				this.receiverEl.style.left = r.left - 5 + 'px';
				this.receiverEl.style.height = r.height + 8 + 'px';
				this.receiverEl.style.width = r.width + 8 + 'px';
			}
			ctx.save();
			ctx.beginPath();
			ctx.lineWidth = this.step.interactive ? 5 : 2;
			ctx.strokeStyle = this.step.interactive ? "rgb(53, 31, 250)" : "black";
			ctx.shadowColor = this.step.interactive ? "rgb(53, 31, 250)" : 'white';
			ctx.shadowBlur = 20;
			if (ctx.roundRect){
				ctx.roundRect(r.left - 4, r.top - 4, r.width + 8, r.height + 8, 5);
			}
			else {
				ctx.rect(r.left - 4, r.top - 4, r.width + 8, r.height + 8);
			}
			ctx.stroke();
			ctx.clip();
			ctx.clearRect(r.left - 4, r.top - 4, r.width + 8, r.height + 8);
			ctx.restore();
		}
		this.position();
	}
	
	skip() {
		if (this.naCheckbox.checked) {
			this.finish();
		}
		else {
			API.put(`flow/${this.id}/cancel`, {
				page: baseName, 
			});
			this.cleanUP();
		}
	}
	
	finish() {
		API.put('flow/'+this.id+'/finish', {
			page: baseName
		});
		this.cleanUP();
	}
	
	cleanUP() {
		remEv(window, 'resize', this.resize);
		remEv(document.body, 'keyup', (event) => {
			if (event.keyCode == AC.ESCAPE_KEY) this.skip();
		});
		this.canvas.remove()
		this.pointer.remove();
		this.box.remove();
		this.measureBox.remove();
		this.receiverEl.remove();
		this.initialised = false;
		if (this.helpOpenAtStart) {
			help.show();
		}
	}
	
}